<template>
    <BreadCrumb PageTitle="Liste des régions" />
    <ListeRegion />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeRegion from "../../components/Region/ListeRegion.vue";

  
    export default defineComponent({
      name: "ListeRegionPage",
      components: {
        BreadCrumb,
        ListeRegion,
      },
    });
  </script>